import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';

import { ProgressbarService } from './progressbar.service';

@Component({
  standalone: false,
  selector: 'app-progressbar',
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.scss']
})
export class ProgressbarComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  show = false;

  constructor(private progressbarService: ProgressbarService
    , private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.subscription = this.progressbarService.isLoading
    .subscribe(
      async (isLoading: boolean) => {
        this.show = await isLoading;
        this.cdr.markForCheck();
      }
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
 